module.exports = ".float {\n  width: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/delivery-notifications/delivery-notifications.component.scss
// module id = ./src/app/pages/delivery-notifications/delivery-notifications.component.scss
// module chunks = main